import { useEffect, useState } from "react";
import { InterviewService } from "../../../../services/InterviewService";

import Select from "../../../../components/Select";

export function Managers({ searchObject, onChange, t }) {
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    InterviewService.GetManagerList().then((data) => setManagers(data));
  }, []);

  return (
    <div>
      <legend className="fontsize-legend">{t("Manager")}</legend>
      <Select
        className="form-select fontsize-legend"
        name="managerId"
        id="managerId"
        onChange={onChange}
        value={searchObject.managerId || ""}
      >
        <option value=""></option>
        {managers.map((managers) => (
          <option
            className="fontsize-legend"
            key={managers.id}
            value={managers.id}
          >
            {managers.nickname}
          </option>
        ))}
      </Select>
    </div>
  );
}
